import React, { Component } from "react";
import "../AuthUsers/AuthUserList.css";
import Config from "../../config";
import Axios from "axios";
import {
  DatePicker,
  Row,
  Spin,
  Col,
  Input,
  Modal,
  Radio,
  Checkbox,
  notification,
  Select,
} from "antd";
import dayjs from "dayjs";
import { Form } from "@ant-design/compatible";
import $, { post } from "jquery";
import PreviousIcon from "../AuthUsers/PreviousIcon.png";
import NextIcon from "../AuthUsers/NextIcon.png";
import paginationDecrement from "../AuthUsers/paginationDecrement.png";
import paginationIncrement from "../AuthUsers/paginationIncrement.png";
import DownloadIcon from "../AuthUsers/DownloadIcon.png";
import CrossIcon from "../AuthUsers/CrossIcon.png";
import SearchIcon from "../AuthUsers/SearchIcon.png";
import { authListObject } from "../../store/broadcaster/BroadcastRegister";
import Postdata from "../Pages/Postdata";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import Attestation from "./Attestation";
const {Option} = Select;
// import AddEventBlock from "../memberSearch/Incidents/AddEventBlock";

export class AttestationList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      columnHeaders: [
        "Sub ID",
        "MBI",
        "Member Name",
        "Attestation Date",
        "Attestated By",
        "Effective Date",
        "Status",
        "Application Date",
        "Attestation type",
        "PCP Name", // alawys add new column at last so it can be easy to add new column without changing existing columnHeaders[number]
        "-----",
        "-----",
        "-----",
        "-----",
        "-----",
      ],
      showAttestationModal: false,
      isPageSearch: false, // default
      selectedUserStatus: null,
      pbpCode: null,
      contractID: null,
      applicationDate: null,
      effectiveDate: null,
      mbi: null,
      isReadOnly: false,
      selectedOption: null,
      pcpNameOptions: [],
      csnpPcpNameOptions: [],
      ssbciPcpNameOptions: [],
      selectedPcpNames: [],
      // attestationDate: null,
      conditions: {
        cvd: false,
        diabetes: false,
        chronicHeartFailure: false,
        cld: false,
        mental: false,
      },
      filterReq: "",
      filterAbv: "",
      filterReference: "",
      filterSubId: "",
      filterMbiId: "",
      filterAttestatedBy: "",
      filterPcpName: "",
      filterMemberName: "",
      filterattestationType: "",
      filterFromData: "",
      filterStatusNew: [],
      attestationdateOnChange: "",
      applicationdateOnChange: "",
      filterToData: "",
      filterDOS: "",
      filterStatus: "",
      filterStatusCode: "",
      subIDToShow: "",
      phoneNumber: "",
      npi: "",
      filterPos: "",
      filterAuth: "",
      filterServicing: "",
      filterFacility: "",
      authListData: [],
      attestationListData: [],
      filterData: [],
      authListLoading: false,
      getNpi: sessionStorage.getItem("npivalue"),
      getPlanName: sessionStorage.getItem("planName"),
      gettaxId: sessionStorage.getItem("taxid"),
      SearchLoading: false,
      searchColumn: "",
      pageNumber: 1,
      totalPages: "",
      // pageSize: 15,
      totalRecords: "",
      totalRecordFound: "",

      currentPage: 1,
      todosPerPage: 10,
      upperPageBound: 5,
      lowerPageBound: 0,
      isPrevBtnActive: "disabled",
      isNextBtnActive: "",
      pageBound: 1,
      activeModule: "CSNP", // ✅ CSNP is selected by default
      id: "",
      filterPageNumber: 1,
      // serialNumber : ""
      showSSBCIModal: false,
      ssbciData: null, // will store API response for the selected member
      pageStatus: false,
      memberDetailsSubscriberId: "",
      ssbci_Id:"",
      authPage:
        this.props.activetab === undefined ||
        this.props.activetab === null ||
        this.props.activetab === ""
          ? "1"
          : this.props.activetab,
      tabName: "authList",
    };
  }

  async componentDidMount() {
    try {
      // Step 1: Call getAuthToken and wait for it to finish
      await this.getAuthToken();

      // Step 2: Then call getAllCSNP
      await this.callActiveModuleAPI();
    //  this.GetAllSsbciPCPName(...args);
    } catch (error) {
      console.error("Error in componentDidMount:", error);
    }
  }

  // Step 1: Fetch Auth Token and save in localStorage
  getAuthToken = async () => {
    try {
      const response = await fetch(`${Config.Enrolment}/GetAuthToken`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          CustID:
            sessionStorage.getItem("planName") === "liberty"
              ? "101"
              : String(sessionStorage.getItem("Tanent")),
          PlanName: sessionStorage.getItem("planName"),
        }),
      });

      if (response.ok) {
        const data = await response.json();
        //console.log("Token Received:", data.TokenInfo.token);

        localStorage.setItem("CNPtoken", data.TokenInfo.token);

        this.setState({
          authToken: data.TokenInfo.token,
          userName: data.TokenInfo.userDetails.userName,
          isButtonVisible: true,
        });
      } else {
        console.error("Failed to fetch authentication token");
      }
    } catch (error) {
      console.error("Error fetching authentication token:", error);
      throw error;
    }
  };
  GetAllCsnpPCPName = async (
    value,
  ) => {
    try {
      this.setState({ SearchLoading: true, isPageSearch: false });
      var mappingDataString = sessionStorage.getItem("taxidNpiMapping");
      let formattedData = [];

      if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
        console.log("inside provider");
        const npi = JSON.parse(sessionStorage.getItem("npivalue"))[0];
        const taxids = JSON.parse(sessionStorage.getItem("taxid")) || [];

        formattedData = taxids.map((taxid) => ({
          TaxID: taxid,
          NPI: npi || null,
        }));
      }
      // Check role
      const roleName = sessionStorage.getItem("rolename") || "";

      if (roleName.includes("Group User") || roleName.includes("IPA User")) {
        console.log("inside Gourp");
        // Choose the correct mapping based on role
        const mappingKey = roleName.includes("IPA User")
          ? "latestTaxidNpiMapping"
          : "taxidNpiMapping";

        const taxidNpiMapping =
          JSON.parse(sessionStorage.getItem(mappingKey)) || [];

        // Transform it into desired structure
        formattedData = taxidNpiMapping.flatMap((item) =>
          (item.NPI || []).map((npi) => ({
            TaxID: item.TaxID || null,
            NPI: npi,
          }))
        );
      }
      // Remove duplicate TaxID + NPI combinations
      formattedData = Array.from(
        new Map(
          formattedData.map((item) => [
            `${item.TaxID}|${item.NPI}`,
            item
          ])
        ).values()
      );

      // You can now send `formattedData` in your payload
      console.log("Formatted Data:", formattedData);
      
      console.log("mappingData", mappingDataString);
      var npiArray = [];
      if (mappingDataString) {
        try {
          var mappingData = JSON.parse(mappingDataString); // <-- Parse JSON string to array
          mappingData.forEach((item) => {
            if (Array.isArray(item.NPI)) {
              item.NPI.forEach((npi) => npiArray.push(npi));
            }
          });
          console.log("npiArray:", npiArray);
        } catch (e) {
          console.error("Failed to parse mappingData", e);
        }
      } else {
        npiArray = JSON.parse(sessionStorage.getItem("npivalue"));
        console.log(npiArray);
      }
      console.log("mapping@@#", mappingDataString);
      console.log("!!!!!", sessionStorage.getItem("taxid"));
      let response = await fetch(`${Config.Enrolment}/GetAllPCPName`, {
        method: "POST",
        headers: {
          Authorization: localStorage.getItem("CNPtoken"), // <-- Using the token from getAuthToken
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageSize: 10,
          pageNumber:0,
          providerDetails: formattedData,   
          // providerNPI: ["1003042581"],
          subsciberId: null, // <- set search box value,
          mbi: null,
          memberName: null,
          attestationType:  null,
          applicationDate: null,
          attestationDate: null,
          attestedBy: null,
          pcpName: [],
          status: null,
          effectiveDate:  null,
          planname: sessionStorage.getItem("planName"),
          custId:
            sessionStorage.getItem("planName") === "liberty"
              ? "101"
              : parseInt(sessionStorage.getItem("Tanent")),
          userName: sessionStorage.getItem("userName"),
        }),
      });

      const data = await response.json();
      console.log("daata",response)
      const pcpNames = data.pcpName || [];
      this.setState({
        csnpPcpNameOptions: pcpNames.filter(name => name)
      });
      console.log("pppp", pcpNames)
    } catch (error) {
      console.error("Failed to fetch CSNP data:", error);
    }
  };

  // Step 2: Call getAllCSNP using the saved token
  getAllCSNP = async (
    value,
    value1,
    value2,
    value3,
    value4,
    value5,
    value6
  ) => {
    try {
      this.setState({ SearchLoading: true, isPageSearch: false });
      var mappingDataString = sessionStorage.getItem("taxidNpiMapping");
      let formattedData = [];

      if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
        console.log("inside provider");
        const npi = JSON.parse(sessionStorage.getItem("npivalue"))[0];
        const taxids = JSON.parse(sessionStorage.getItem("taxid")) || [];

        formattedData = taxids.map((taxid) => ({
          TaxID: taxid,
          NPI: npi || null,
        }));
      }
      // Check role
      const roleName = sessionStorage.getItem("rolename") || "";

      if (roleName.includes("Group User") || roleName.includes("IPA User")) {
        console.log("inside Gourp");
        // Choose the correct mapping based on role
        const mappingKey = roleName.includes("IPA User")
          ? "latestTaxidNpiMapping"
          : "taxidNpiMapping";

        const taxidNpiMapping =
          JSON.parse(sessionStorage.getItem(mappingKey)) || [];

        // Transform it into desired structure
        formattedData = taxidNpiMapping.flatMap((item) =>
          (item.NPI || []).map((npi) => ({
            TaxID: item.TaxID || null,
            NPI: npi,
          }))
        );
      }
      // Remove duplicate TaxID + NPI combinations
      formattedData = Array.from(
        new Map(
          formattedData.map((item) => [
            `${item.TaxID}|${item.NPI}`,
            item
          ])
        ).values()
      );

      // You can now send `formattedData` in your payload
      console.log("Formatted Data:", formattedData);
      
      console.log("mappingData", mappingDataString);
      var npiArray = [];
      if (mappingDataString) {
        try {
          var mappingData = JSON.parse(mappingDataString); // <-- Parse JSON string to array
          mappingData.forEach((item) => {
            if (Array.isArray(item.NPI)) {
              item.NPI.forEach((npi) => npiArray.push(npi));
            }
          });
          console.log("npiArray:", npiArray);
        } catch (e) {
          console.error("Failed to parse mappingData", e);
        }
      } else {
        npiArray = JSON.parse(sessionStorage.getItem("npivalue"));
        console.log(npiArray);
      }
      console.log("mapping@@#", mappingDataString);
      console.log("!!!!!", sessionStorage.getItem("taxid"));
      let response = await fetch(`${Config.Enrolment}/getAllCSNP`, {
        method: "POST",
        headers: {
          Authorization: localStorage.getItem("CNPtoken"), // <-- Using the token from getAuthToken
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageSize: 10,
          pageNumber:
            this.state.pageStatus != value ? 1 : this.state.currentPage,
          providerDetails: formattedData,
        
          // providerNPI: ["1003042581"],
          subsciberId: this.state.filterSubId || null, // <- set search box value,
          mbi: this.state.filterMbiId || null,
          memberName: this.state.filterMemberName || null,
          attestationType: this.state.filterattestationType || null,
          applicationDate: this.state.applicationdateOnChange || null,
          attestationDate: this.state.attestationdateOnChange || null,
          attestedBy: this.state.filterAttestatedBy || null,
          // pcpName: this.state.filterPcpName 
          // ? [this.state.filterPcpName] 
          // : [],
          pcpName: this.state.selectedPcpNames
          ? this.state.selectedPcpNames
          : [],
          status: this.state.filterStatusCode || null,
          effectiveDate: this.state.filterDOS || null,
          planname: sessionStorage.getItem("planName"),
          custId:
            sessionStorage.getItem("planName") === "liberty"
              ? "101"
              : parseInt(sessionStorage.getItem("Tanent")),
          userName: sessionStorage.getItem("userName"),
        }),
      });

      const data = await response.json();
      //console.log("daaata",data)
      if (
        data.list.length != 0 ||
        data.list != null ||
        data.list != undefined ||
        data.list != ""
      ) {
        this.setState({
          attestationListData: data.list,
          totalPages: Math.ceil(data.totalRecordCount / 10),
          totalRecords: data.totalRecordCount,
          authListLoading: true,
          SearchLoading: false,
          // filterData : this.state.filterData,
          totalRecordFound: data.totalRecordCount,
        });
      } else {
        this.setState({
          authListData: [],
          authListLoading: true,
        });
      }
    } catch (error) {
      console.error("Failed to fetch CSNP data:", error);
    }
  };
  GetAllSsbciPCPName = async (
    value,
    value1,
    value2,
    value3,
    value4,
    value5,
    value6
  ) => {
    try {
      console.log("inside*** ssbci")
      this.setState({ SearchLoading: true, isPageSearch: false });
      var mappingDataString = sessionStorage.getItem("taxidNpiMapping");
      let formattedData = [];

      if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
        console.log("inside provider");
        const npi = JSON.parse(sessionStorage.getItem("npivalue"))[0];
        const taxids = JSON.parse(sessionStorage.getItem("taxid")) || [];

        formattedData = taxids.map((taxid) => ({
          TaxID: taxid,
          NPI: npi || null,
        }));
      }
      // Check role
      const roleName = sessionStorage.getItem("rolename") || "";

      if (roleName.includes("Group User") || roleName.includes("IPA User")) {
        console.log("inside Gourp");
        // Choose the correct mapping based on role
        const mappingKey = roleName.includes("IPA User")
          ? "latestTaxidNpiMapping"
          : "taxidNpiMapping";

        const taxidNpiMapping =
          JSON.parse(sessionStorage.getItem(mappingKey)) || [];

        // Transform it into desired structure
        formattedData = taxidNpiMapping.flatMap((item) =>
          (item.NPI || []).map((npi) => ({
            TaxID: item.TaxID || null,
            NPI: npi,
          }))
        );
      }
      // Remove duplicate TaxID + NPI combinations
      formattedData = Array.from(
        new Map(
          formattedData.map((item) => [
            `${item.TaxID}|${item.NPI}`,
            item
          ])
        ).values()
      );

      // You can now send `formattedData` in your payload
      console.log("Formatted Data:", formattedData);
      
      console.log("mappingData", mappingDataString);
      var npiArray = [];
      if (mappingDataString) {
        try {
          var mappingData = JSON.parse(mappingDataString); // <-- Parse JSON string to array
          mappingData.forEach((item) => {
            if (Array.isArray(item.NPI)) {
              item.NPI.forEach((npi) => npiArray.push(npi));
            }
          });
          console.log("npiArray:", npiArray);
        } catch (e) {
          console.error("Failed to parse mappingData", e);
        }
      } else {
        npiArray = JSON.parse(sessionStorage.getItem("npivalue"));
        console.log(npiArray);
      }
      console.log("mapping@@#", mappingDataString);
      console.log("!!!!!", sessionStorage.getItem("taxid"));
      let response = await fetch(`${Config.Enrolment}/GetSsbciPCPName`, {
        method: "POST",
        headers: {
          Authorization: localStorage.getItem("CNPtoken"), // <-- Using the token from getAuthToken
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageSize: 10,
          pageNumber: 1,
          providerDetails: formattedData,
        
          // providerNPI: ["1003042581"],
          subsciberId: null, // <- set search box value,
          mbi: null,
          memberName: null,
          attestationType: null,
          applicationDate: null,
          attestationDate: null,
          attestedBy: null,
          // pcpName: this.state.filterPcpName 
          // ? [this.state.filterPcpName] 
          // : [],
          pcpName: [],
          status: null,
          effectiveDate: null,
          planname: sessionStorage.getItem("planName"),
          custId:
            sessionStorage.getItem("planName") === "liberty"
              ? "101"
              : parseInt(sessionStorage.getItem("Tanent")),
          userName: sessionStorage.getItem("userName"),
        }),
      });

      const data = await response.json();
      const pcpNames = data.pcpName || [];
      this.setState({
        ssbciPcpNameOptions: pcpNames.filter(name => name)
      });
      
    } catch (error) {
      console.error("Failed to fetch CSNP data:", error);
    }
  };
  getAllSSBCI = async (
    value
  ) => {
    try {
      console.log("inside*** ssbci")
      this.setState({ SearchLoading: true, isPageSearch: false });
      var mappingDataString = sessionStorage.getItem("taxidNpiMapping");
      let formattedData = [];

      if (sessionStorage.getItem("ProviderRole") === "PROVIDER") {
        console.log("inside provider");
        const npi = JSON.parse(sessionStorage.getItem("npivalue"))[0];
        const taxids = JSON.parse(sessionStorage.getItem("taxid")) || [];

        formattedData = taxids.map((taxid) => ({
          TaxID: taxid,
          NPI: npi || null,
        }));
      }
      // Check role
      const roleName = sessionStorage.getItem("rolename") || "";

      if (roleName.includes("Group User") || roleName.includes("IPA User")) {
        console.log("inside Gourp");
        // Choose the correct mapping based on role
        const mappingKey = roleName.includes("IPA User")
          ? "latestTaxidNpiMapping"
          : "taxidNpiMapping";

        const taxidNpiMapping =
          JSON.parse(sessionStorage.getItem(mappingKey)) || [];

        // Transform it into desired structure
        formattedData = taxidNpiMapping.flatMap((item) =>
          (item.NPI || []).map((npi) => ({
            TaxID: item.TaxID || null,
            NPI: npi,
          }))
        );
      }
      // Remove duplicate TaxID + NPI combinations
      formattedData = Array.from(
        new Map(
          formattedData.map((item) => [
            `${item.TaxID}|${item.NPI}`,
            item
          ])
        ).values()
      );

      // You can now send `formattedData` in your payload
      console.log("Formatted Data:", formattedData);
      
      console.log("mappingData", mappingDataString);
      var npiArray = [];
      if (mappingDataString) {
        try {
          var mappingData = JSON.parse(mappingDataString); // <-- Parse JSON string to array
          mappingData.forEach((item) => {
            if (Array.isArray(item.NPI)) {
              item.NPI.forEach((npi) => npiArray.push(npi));
            }
          });
          console.log("npiArray:", npiArray);
        } catch (e) {
          console.error("Failed to parse mappingData", e);
        }
      } else {
        npiArray = JSON.parse(sessionStorage.getItem("npivalue"));
        console.log(npiArray);
      }
      console.log("mapping@@#", mappingDataString);
      console.log("!!!!!", sessionStorage.getItem("taxid"));
      let response = await fetch(`${Config.Enrolment}/GetAllSSBCI`, {
        method: "POST",
        headers: {
          Authorization: localStorage.getItem("CNPtoken"), // <-- Using the token from getAuthToken
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          pageSize: 10,
          pageNumber:
            this.state.pageStatus != value ? 1 : this.state.currentPage,
          providerDetails: formattedData,
        
          // providerNPI: ["1003042581"],
          subsciberId: this.state.filterSubId || null, // <- set search box value,
          mbi: this.state.filterMbiId || null,
          memberName: this.state.filterMemberName || null,
          attestationType: this.state.filterattestationType || null,
          applicationDate: this.state.applicationdateOnChange || null,
          attestationDate: this.state.attestationdateOnChange || null,
          attestedBy: this.state.filterAttestatedBy || null,
          // pcpName: this.state.filterPcpName 
          // ? [this.state.filterPcpName] 
          // : [],
          pcpName: this.state.selectedPcpNames
          ? this.state.selectedPcpNames
          : [],
          status: this.state.filterStatusCode || null,
          effectiveDate: this.state.filterDOS || null,
          planname: sessionStorage.getItem("planName"),
          custId:
            sessionStorage.getItem("planName") === "liberty"
              ? "101"
              : parseInt(sessionStorage.getItem("Tanent")),
          userName: sessionStorage.getItem("userName"),
        }),
      });

      const data = await response.json();
      //console.log("daaata",data)
      if (
        data.list.length != 0 ||
        data.list != null ||
        data.list != undefined ||
        data.list != ""
      ) {
        this.setState({
          attestationListData: data.list,
          totalPages: Math.ceil(data.totalRecordCount / 10),
          totalRecords: data.totalRecordCount,
          authListLoading: true,
          SearchLoading: false,
          // filterData : this.state.filterData,
          totalRecordFound: data.totalRecordCount,
        });
      } else {
        this.setState({
          authListData: [],
          authListLoading: true,
        });
      }
    } catch (error) {
      console.error("Failed to fetch CSNP data:", error);
    }
  };
  callActiveModuleAPI = (...args) => {
    const {
      activeModule,
      csnpPcpNameOptions,
      ssbciPcpNameOptions
    } = this.state;
  
    if (activeModule === "SSBCI") {
      this.getAllSSBCI(...args);
  
      // Call PCP API only if data not loaded
      if (!ssbciPcpNameOptions.length) {
        this.GetAllSsbciPCPName();
      }
    } else {
      this.getAllCSNP(...args);
  
      // Call PCP API only if data not loaded
      if (!csnpPcpNameOptions.length) {
        this.GetAllCsnpPCPName();
      }
    }
  };
  

  componentDidUpdate() {
    $("ul li.active").removeClass("active");
    $("ul li#" + this.state.currentPage).addClass("active");
    // this.AdmissionListUpdatedbyEvents()
  }
  filterOnchange = (e) => {
    console.log("eee@@", e.target.value);
    //console.log("ffff@@",e.target.name)
    const name = e.target.name;
    const value = e.target.value;
    this.setState({
      [name]: value,
      currentPage: 1,
      isPageSearch: true
    });
  };

  columnAscendingOrder = (event, sortKey) => {
    console.log("sort111", event);
    console.log("sort222", sortKey);
    const data = this.state.attestationListData;
    data.sort((a, b) => {
      const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
      const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
      //  return a1.localeCompare(b1);
      return String(a1).localeCompare(String(b1)); // ensure both are strings
    });
    this.setState({ data });
  };

  ColumnDescendingOrder = (event, sortKey) => {
    const data = this.state.attestationListData;
    data.sort((a, b) => {
      const a1 = a[sortKey] === null || a[sortKey] === "" ? "" : a[sortKey];
      const b1 = b[sortKey] === null || a[sortKey] === "" ? "" : b[sortKey];
      return String(b1).localeCompare(String(a1)); // ensure both are strings
    });
    this.setState({ data });
  };

  dosOnChange = (date, dateString) => {
    //console.log("QQQQ",dateString)
    this.setState({
      filterDOS: dateString,
      isPageSearch: true
    });
  };

  fromdateOnChange = (date, dateString) => {
    // //console.log(dateString)
    this.setState({
      filterFromData: dateString,
    });
  };

  todateOnChange = (date, dateString) => {
    // //console.log(dateString)
    this.setState({
      filterToData: dateString,
    });
  };
  attestationdateOnChange = (date, dateString) => {
    //console.log("date@@",dateString)
    this.setState({
      attestationdateOnChange: dateString,
      isPageSearch: true
    });
  };
  applicationdateOnChange = (date, dateString) => {
    console.log("date@@",dateString)
    this.setState({
      applicationdateOnChange: dateString,
      isPageSearch: true
    });
  };
  statusToLookupCodes = {
    Pending: ["CSNP_APPR", "SSBCI_APPR", "SSBCI_Pend"], // Added SSBCI_Pend
    Completed: [
      "CSNP_AUCCNP", "CSNP_AUCCWN", "CSNP_AUCICCP", "CSNP_ACCP",
      "SSBCI_AUCCNP", "SSBCI_AUCCWN", "SSBCI_AUCICCP", "SSBCI_ACCP",
      "SSBCI_CCB", "SSBCI_CCC", "SSBCI_CCCP", "SSBCI_UCCNP", "SSBCI_UCCWN" // Added Ultimate codes
    ],
  };

  fromStatusChange = (selectedStatuses) => {
    let selectedCodes = [];

    selectedStatuses.forEach((status) => {
      if (this.statusToLookupCodes[status]) {
        selectedCodes = selectedCodes.concat(this.statusToLookupCodes[status]);
      }
    });

    selectedCodes = [...new Set(selectedCodes)];
    console.log(
      "Mapped Lookup Codes (to be filtered):",
      selectedCodes.join(",")
    );

    this.setState({
      filterStatusCode: selectedCodes.join(","),
    });
  };

  getStatusLabel = (statusCode) => {
    for (const [label, codes] of Object.entries(this.statusToLookupCodes)) {
      if (codes.includes(statusCode)) {
        return label;
      }
    }
    return statusCode; // fallback if not found
  };

  tableHeader = () => {
    const { getFieldDecorator } = this.props.form;
    const { activeModule, csnpPcpNameOptions, ssbciPcpNameOptions } = this.state;

    const pcpNameOptions =
         activeModule === "SSBCI"
         ? ssbciPcpNameOptions
         : csnpPcpNameOptions;
    const allSelected = pcpNameOptions.length > 0 && this.state.selectedPcpNames.length === pcpNameOptions.length;
    return (
      <thead>
        <tr>
          <th>
            <div style={{ marginTop: "-30px" }}>
              <div>#</div>
            </div>
          </th>
          {/* ----------------------------------------- */}
          {/* Sub ID */}
          <th style={{ width: "120px" }}>
            <div>
              <div className="sortingArrows">
                <div> {this.state.columnHeaders[0]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "subsciberId")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) =>
                      this.ColumnDescendingOrder(e, "subsciberId")
                    }
                  ></div>
                </div>
              </div>

              <div>
                <Input
                  className="inputStyle"
                  name="filterSubId"
                  type="text"
                  value={this.state.filterSubId}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  size="small"
                  onPressEnter={this.callActiveModuleAPI}
                />
              </div>
            </div>
          </th>
          {/* ----------------------------------------- */}
          {/* MBI ID */}
          <th style={{ width: "120px" }}>
            <div>
              <div className="sortingArrows">
                <div> {this.state.columnHeaders[1]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "mbi")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "mbi")}
                  ></div>
                </div>
              </div>

              <div>
                <Input
                  className="inputStyle"
                  name="filterMbiId"
                  type="text"
                  value={this.state.filterMbiId}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  size="small"
                  onPressEnter={this.callActiveModuleAPI}
                />
              </div>
            </div>
          </th>
          {/* -------------------------------------------------- */}
          {/* Member name */}
          <th style={{ width: "150px" }}>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[2]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "memberName")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "memberName")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterMemberName"
                  type="text"
                  value={this.state.filterMemberName}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.callActiveModuleAPI(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          {/* -------------------------------------------------- */}
          {/* Application Type */}
          <th style={{ width: "130px" }}>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[8]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "attestationType")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "attestationType")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterattestationType"
                  type="text"
                  value={this.state.filterattestationType}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.callActiveModuleAPI(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          {/* -------------------------------------------------- */}
          {/* Application Date */}
          <th style={{ width: "135px" }}>
            <div>
              <div className="sortingArrows">
                  {this.state.columnHeaders[7]}
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) =>
                      this.columnAscendingOrder(e, "applicationDate")
                    }
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) =>
                      this.ColumnDescendingOrder(e, "applicationDate")
                    }
                  ></div>
                </div>
              </div>
              <div>
                {getFieldDecorator("applicationdateOnChange", {
                  initialValue:
                    this.state.applicationdateOnChange != "" ||
                    this.state.applicationdateOnChange != null
                      ? this.state.applicationdateOnChange
                      : "",
                })(
                  <DatePicker
                    size="small"
                    suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.applicationdateOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
              </div>
            </div>
          </th>
          {/* -------------------------------------------------- */}
          {/* Attestation Date */}
          <th style={{ width: "135px" }}>
            <div>
              <div className="sortingArrows">
                  {this.state.columnHeaders[3]}
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) =>
                      this.columnAscendingOrder(e, "attestationDate")
                    }
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) =>
                      this.ColumnDescendingOrder(e, "attestationDate")
                    }
                  ></div>
                </div>
              </div>
              <div>
                {getFieldDecorator("attestationdateOnChange", {
                  initialValue:
                    this.state.attestationdateOnChange != "" ||
                    this.state.attestationdateOnChange != null
                      ? this.state.attestationdateOnChange
                      : "",
                })(
                  <DatePicker
                    size="small"
                    suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.attestationdateOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
              </div>
            </div>
          </th>
           {/* -------------------------------------------------- */}
            {/* PCP Name */}
            <th style={{ width: "150px" }}>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[9]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "pcpName")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "pcpName")}
                  ></div>
                </div>
              </div>
              <div>
                <Select
                  mode="multiple"
                  size="small"
                  className="inputStyle"
                  style={{ width: "100%", marginTop: "10px" }}
                  placeholder="Select PCP"
                  value={this.state.selectedPcpNames}
                  onChange={this.handlePcpChange}
               //   onChange={this.filterOnchange}
                >
                <Option
                key="ALL" 
                value="ALL"
                disabled={pcpNameOptions.length === 0}>
                    {pcpNameOptions.length === 0 ? "No Data" : allSelected ? "Unselect All" : "Select All"}
                </Option>
 
                {pcpNameOptions.map((name) => (
                  <Option key={name} value={name}>
                      {name}
                  </Option>
                ))}
               </Select>
              </div>
            </div>
          </th>
          {/* -------------------------------------------------- */}
          {/* Attestated By */}
          <th style={{ width: "150px" }}>
            <div>
              <div className="sortingArrows">
                <div>{this.state.columnHeaders[4]}</div>
                <div>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "attestedBy")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "attestedBy")}
                  ></div>
                </div>
              </div>
              <div>
                <Input
                  size="small"
                  className="inputStyle"
                  name="filterAttestatedBy"
                  type="text"
                  value={this.state.filterAttestatedBy}
                  onChange={this.filterOnchange}
                  placeholder="Enter"
                  onPressEnter={() =>
                    this.callActiveModuleAPI(
                      false,
                      this.state.currentPage,
                      this.state.upperPageBound,
                      this.state.lowerPageBound,
                      this.state.pageBound,
                      this.state.isPrevBtnActive,
                      this.state.isNextBtnActive
                    )
                  }
                />
              </div>
            </div>
          </th>
          {/* -------------------------------------------------- */}
          {/* D.O.S */}
          <th style={{ width: "135px" }}>
            <div>
              <div className="sortingArrows">
                <div style={{ marginTop: "-8px" }}>
                  {this.state.columnHeaders[5]}
                </div>
                <div style={{ marginTop: "-10px" }}>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) =>
                      this.columnAscendingOrder(e, "effectiveDate")
                    }
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) =>
                      this.ColumnDescendingOrder(e, "effectiveDate")
                    }
                  ></div>
                </div>
              </div>
              <div>
                {getFieldDecorator("filterDOS", {
                  initialValue:
                    this.state.filterDOS != "" || this.state.filterDOS != null
                      ? this.state.filterDOS
                      : "",
                })(
                  <DatePicker
                    size="small"
                    suffixIcon
                    className="inputStyle datePicker"
                    style={{ width: "100%", marginTop: "10px" }}
                    onChange={(date, dateString) =>
                      this.dosOnChange(date, dateString)
                    }
                    // disabledDate={d =>
                    //     !d || d.isAfter(today, "day")
                    // }
                    format={"MM/DD/YYYY"}
                    placeholder="Select"
                  />
                )}{" "}
              </div>
            </div>
          </th>
          {/* -------------------------------------------------- */}
          {/* Status */}
          <th style={{ width: "110px" }}>
            <div>
              <div className="sortingArrows">
                <div style={{ marginTop: "-8px" }}>
                  {this.state.columnHeaders[6]}
                </div>
                <div style={{ marginTop: "-10px" }}>
                  <div
                    className="triangle triangle-4"
                    onClick={(e) => this.columnAscendingOrder(e, "status")}
                  ></div>
                  <div
                    className="triangle triangle-5"
                    onClick={(e) => this.ColumnDescendingOrder(e, "status")}
                  ></div>
                </div>
              </div>
              <div>
                {getFieldDecorator("filterStatusNew", {
                  initialValue:
                    this.state.filterStatusNew &&
                    this.state.filterStatusNew.length > 0
                      ? this.state.filterStatusNew
                      : [],
                })(
                  <Select
                    mode="multiple"
                    size="small"
                    className="inputStyle"
                    style={{ width: "100%", marginTop: "10px" }}
                    placeholder="Select status"
                    onChange={(value) => this.fromStatusChange(value)}
                  >
                    {/* <Select.Option value="Not started">
                      Not started
                    </Select.Option> */}
                    <Select.Option value="Pending">Pending</Select.Option>
                    <Select.Option value="Completed">Completed</Select.Option>
                  </Select>
                )}
              </div>
            </div>
          </th>
        </tr>
      </thead>
    );
  };

  getAttestationDetails = (user) => {
    const { activeModule } = this.state;
    if (user?.patientCondition) {
  let patientConditionData = user.patientCondition;

  // ✅ Parse if it's a JSON string
  if (typeof patientConditionData === "string") {
    try {
      patientConditionData = JSON.parse(patientConditionData);
    } catch (err) {
      console.error("Failed to parse patientCondition JSON:", err);
      patientConditionData = [];
    }
  }

  if (Array.isArray(patientConditionData)) {
    const ssbciConditions = patientConditionData.map(item => ({
      LookUp_Code: item.Lookup_Code || item.LookUp_Code, // handle both naming variants
      LookUp_Desc: item.LookUp_Desc,
      selected: item.selected,
    }));

    console.log("✅ Mapped SSBCI conditions:", ssbciConditions);
    this.setState({ ssbciConditions });
  }
}
    
    this.setState({ subIDToShow: user.subsciberId, pbpCode: user.pbpCode, contractID: user.contractID, mbi: user.mbi, applicationDate: user.applicationDate, effectiveDate: user.effectiveDate, enrollmentStatus: user?.status, phoneNumber: user?.phoneNumber, npi: user?.npi})
    console.log("annnn", user);
    const readOnlyStatuses = [
      "CSNP_ACCP", "CSNP_AUCCNP", "CSNP_AUCCWN", "CSNP_AUCICCP",
      "SSBCI_ACCP", "SSBCI_AUCCWN", "SSBCI_AUCCNP",
      "SSBCI_CCB", "SSBCI_CCC", "SSBCI_CCCP", "SSBCI_UCCNP", "SSBCI_UCCWN" // Added Ultimate
      ];

    const isReadOnly = readOnlyStatuses.includes(user.status);
    const chronicDetails = (user.chronicDetails || "")
      .split(",")
      .map((s) => s.trim());

    // 🔹 Case 1: Status is CSNP_AUCCNP → Not my patient
    if (user.status === "CSNP_AUCCNP") {
      this.setState({
        selectedOption: "notMyPatient",
        conditions: { cvd: false, diabetes: false, chronicHeartFailure: false,  cld: false, mental: false },
        attestationDate: user.attestationDate
          ? dayjs(user.attestationDate)
          : null,
        isReadOnly,
        selectedUserStatus: user.status,
        showAttestationModal: true,
        originalUserData: {
          selectedOption: "notMyPatient",
          conditions: { cvd: false, diabetes: false, chronicHeartFailure: false, cld: false, mental: false },
          attestationDate: user.attestationDate
            ? dayjs(user.attestationDate)
            : null,
        },
      });
      return;
    }

    // 🔹 Case 2: chronicDetails contains PRSNC_CONF_COND → No conditions confirmed
    if (chronicDetails.includes("PRSNC_CONF_COND")) {
      this.setState({
        selectedOption: "noConditions",
        conditions: { cvd: false, diabetes: false, chronicHeartFailure: false, cld: false, mental: false },
        attestationDate: user.attestationDate
          ? dayjs(user.attestationDate)
          : null,
        isReadOnly,
        selectedUserStatus: user.status,
        showAttestationModal: true,
        originalUserData: {
          selectedOption: "noConditions",
          conditions: { cvd: false, diabetes: false, chronicHeartFailure: false, cld: false, mental: false },
          attestationDate: user.attestationDate
            ? dayjs(user.attestationDate)
            : null,
        },
      });
      return;
    }

    // 🔹 Case 3: chronicDetails include DIAB, CVD, SBP → hasConditions + checkboxes
    const selectedOption = "hasConditions";
    const conditions = {
      cvd: chronicDetails.includes("CVD"),
      diabetes: chronicDetails.includes("DIAB"),
      chronicHeartFailure: chronicDetails.includes("CHF"),
      cld: chronicDetails.includes("CLD"),
      mental: chronicDetails.includes("SBP"),
    };

    this.setState({
      subIDToShow: user.subsciberId,
      selectedOption,
      conditions,
      attestationDate: user.attestationDate
        ? dayjs(user.attestationDate)
        : null,
      pbpCode: user.pbpCode,
      contractID: user.contractID,
      mbi: user.mbi,
      isReadOnly,
      selectedUserStatus: user.status,
      showAttestationModal: true,
      originalUserData: {
        selectedOption,
        conditions,
        attestationDate: user.attestationDate
          ? dayjs(user.attestationDate)
          : null,
      },
    });

    if(activeModule === "SSBCI" ){
      const planName = sessionStorage.getItem("planName");
    
      const resolvedPhoneNumber =
      user?.phoneNumber && String(user.phoneNumber).trim() !== ""
        ? String(user.phoneNumber).replace(/\D/g, "").slice(0, 10)
        : "9999999999";
  
      this.setState((prevState) => ({
        selectedOption: user.status,
        ssbci_Id:user.ssbci_Id,
        // Always start phone number 9999999999
        phoneNumber: resolvedPhoneNumber, // default applied here
        npi:
          planName === "ultimate"
            ? prevState.npi || this.getFirstProviderNpi() || ""
            : "",
       }))

    }
  };

  handleClick = (event) => {
    let listid = Number(event.target.id);
    this.setState(
      {
        currentPage: listid,
        // filterPageNumber : listid
        // todosPerPage: 20,
        pageStatus: false,
      },
      () => {
        this.setPrevAndNextBtnClass(listid);
        this.callActiveModuleAPI(
          false,
          this.state.currentPage,
          this.state.upperPageBound,
          this.state.lowerPageBound,
          this.state.pageBound,
          this.state.isPrevBtnActive,
          this.state.isNextBtnActive
        );
      }
    );
    $("ul li.active").removeClass("active");
    $("ul li#" + listid).addClass("active");
  };

  setPrevAndNextBtnClass = (listid) => {
    //console.log("in setp",listid)
    var totalPage;

    totalPage = this.state.totalRecords;
    //console.log("ttppp",totalPage)

    this.setState({
      isNextBtnActive: "disabled",
      pageStatus: false,
    });
    this.setState({ isPrevBtnActive: "disabled" });
    if (totalPage === listid && totalPage > 1) {
      //console.log("in 111")
      this.setState({ isPrevBtnActive: "" });
    } else if (listid === 1 && totalPage > 1) {
      //console.log("in 222")
      this.setState({ isNextBtnActive: "" });
    } else if (totalPage > 1) {
      //console.log("in 333")
      this.setState({ isNextBtnActive: "" });
      this.setState({ isPrevBtnActive: "" });
    }
  };

  btnPrevClick = () => {
    if ((this.state.currentPage - 1) % this.state.pageBound === 0) {
      this.setState({
        upperPageBound: this.state.upperPageBound - this.state.pageBound,
      });
      this.setState({
        lowerPageBound: this.state.lowerPageBound - this.state.pageBound,
      });
    }
    let listid = this.state.currentPage - 1;
    this.setState({ currentPage: listid }, () => {
      this.setState({
        pageStatus: false,
      });
      this.setPrevAndNextBtnClass(listid);
      this.callActiveModuleAPI(
        false,
        this.state.currentPage,
        this.state.upperPageBound,
        this.state.lowerPageBound,
        this.state.pageBound,
        this.state.isPrevBtnActive,
        this.state.isNextBtnActive
      );
    });
  };

  btnNextClick = () => {
    // this condition is written when currentPage + 1 is grater then upperPageBound then show ... before pagination
    if (this.state.currentPage + 1 > this.state.upperPageBound) {
      this.setState({
        upperPageBound: this.state.upperPageBound + this.state.pageBound,
      });
      this.setState({
        lowerPageBound: this.state.lowerPageBound + this.state.pageBound,
      });
    }
    let listid = this.state.currentPage + 1;
    //console.log("llll",listid)
    this.setState({ currentPage: listid }, () => {
      this.setState({
        pageStatus: false,
      });
      this.setPrevAndNextBtnClass(listid);
      this.callActiveModuleAPI(
        false,
        this.state.currentPage,
        this.state.upperPageBound,
        this.state.lowerPageBound,
        this.state.pageBound,
        this.state.isPrevBtnActive,
        this.state.isNextBtnActive
      );
    });
  };

  resetFields = () => {
    this.setState(
      {
        filterAttestatedBy: "",
        filterPcpName: "",
        filterReq: "",
        filterAbv: "",
        filterReference: "",
        filterSubId: "",
        filterMbiId: "",
        selectedPcpNames: [],
        filterMemberName: "",
        filterattestationType: "",
        filterFromData: "",
        filterStatusNew: [],
        attestationdateOnChange: "",
        applicationdateOnChange: "",
        filterToData: "",
        filterDOS: "",
        // filterStatus: "",
        filterStatusCode: "",
        filterPos: "",
        filterAuth: "",
        filterServicing: "",
        filterFacility: "",
        currentPage: 1,
        todosPerPage: 10,
        // filterPageNumber : 1,
        pageStatus: false,
        totalPages: "",
        // currentPage: 1,
        // todosPerPage: 10,
        upperPageBound: 5,
        lowerPageBound: 0,
        isPrevBtnActive: "disabled",
        isNextBtnActive: "",
        pageBound: 1,
      },
      () => {
        this.callActiveModuleAPI(true, 1, 5, 0, 1);
        this.props.form.setFieldsValue({
          filterDOS: "",
        });
        this.props.form.setFieldsValue({
          filterToData: "",
        });
        this.props.form.setFieldsValue({
          filterFromData: "",
          filterStatusNew: [],
          attestationdateOnChange: "",
          applicationdateOnChange: "",
        });
      }
    );
  };
  //----------------------------------------------------
  handleOptionChange = (e) => {
     console.log("e.target.value", e.target.value)
    const selectedOption = e.target.value;

    this.setState({
      selectedOption,
      conditions:
        selectedOption === "hasConditions"
          ? this.state.conditions // Keep current values
          : {
              cvd: false,
              diabetes: false,
              chronicHeartFailure: false,
              cld: false,
              mental: false,
            }, // Reset all checkboxes if other radio selected
    });
  };

  handleCheckboxChange = (e) => {
    //console.log("handleCheckboxChange",e.target.name)
    const { name, checked } = e.target;
    this.setState((prevState) => ({
      conditions: {
        ...prevState.conditions,
        [name]: checked,
      },
    }));
  };
  handleModalCancel = () => {
    this.setState({ 
      showAttestationModal: false,
      phoneNumber: "",
      npi: "",
     });
  };


   formatDate = (date) => {
    if (!date) return "";        // null, empty, undefined → ""
    const d = dayjs(date);
    return d.isValid() ? d.format("YYYY-MM-DD") : "";
  };

  handleModalSave = () => {
    console.log("inside update button");
    const { selectedOption, conditions, attestationDate, activeModule, applicationDate, effectiveDate } = this.state;
    this.setState({ isLoading: true, isReadOnly: true });

    // First Name and Last Name logic
    const username = sessionStorage.getItem("userName") || "";
    const nameParts = username.trim().split(/\s+/);
    const Firstname = nameParts.slice(0, -1).join(" ");
    const Lastname = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
    // Common fields
    const commonFields = {
      PlanName: sessionStorage.getItem("planName"),
      username: sessionStorage.getItem("userName"),
      custId:
        sessionStorage.getItem("planName") === "liberty"
          ? "101"
          : parseInt(sessionStorage.getItem("Tanent")),
      mbi: this.state.mbi,
      PbpCode: this.state.pbpCode,
      contractID: this.state.contractID,
      attestationDate: attestationDate?.format("YYYY-MM-DD"),
    };
  
    let payload = {};
  
    // ✅ CASE 1: CSNP payload
    if (activeModule === "CSNP") {
      payload = {
        ...commonFields,
      myPatient: selectedOption === "hasConditions" ? 1 : 0,
      patientCondition: {
        cardiovascular: 0,
        diabetes: 0,
        mentalHealth: 0,
        chronicHeartFailure: 0,
        chronicLungDisorder: 0,
        myPatientConditionDoNotConfirm: 0,
        notMyPatient: 0,
      },
    };

    if (selectedOption === "hasConditions") {
      payload.patientCondition.cardiovascular = conditions?.cvd ? 1 : 0;
      payload.patientCondition.diabetes = conditions?.diabetes ? 1 : 0;
      payload.patientCondition.chronicHeartFailure = conditions?.chronicHeartFailure ? 1 : 0;
      payload.patientCondition.chronicLungDisorder = conditions?.cld ? 1 : 0;
      payload.patientCondition.mentalHealth = conditions?.mental ? 1 : 0;
    } else if (selectedOption === "noConditions") {
      payload.patientCondition.myPatientConditionDoNotConfirm = 1;
    } else if (selectedOption === "notMyPatient") {
      payload.patientCondition.notMyPatient = 1;
    }
  }

    // ✅ CASE 2: SSBCI payload
    else if (activeModule === "SSBCI") {
      payload = {
        ...commonFields,
        phoneNumber: this.state.phoneNumber, // Added
        npi: this.state.npi,                 // Added
        Firstname: Firstname,
        Lastname: Lastname,
        myPatient: 0, // default
        patientCondition: {
          myPatientConditionDoNotConfirm: 0,
          notMyPatient: 0,
        },
        applicationDate: this.formatDate(applicationDate),
        effectiveDate: this.formatDate(effectiveDate),
        ssbci_Id:this.state.ssbci_Id
      };
  
      // Logic based on selectedOption
      if (selectedOption === "SSBCI_ACCP") {
        payload.myPatient = 1;
      } else if (selectedOption === "SSBCI_AUCCWN") {
        payload.patientCondition.myPatientConditionDoNotConfirm = 1;
      } else if (selectedOption === "SSBCI_AUCCNP") {
        payload.patientCondition.notMyPatient = 1;
      }
    }
  
    console.log("Final Payload:", payload);
  
    // ✅ Select endpoint dynamically
    const endpoint =
      activeModule === "SSBCI"
        ? `${Config.Enrolment}/CreateSSBCISubscribers`
        : `${Config.Enrolment}/CreateCSNPSubscribers`;
  
    // ✅ Call API
    fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("CNPtoken"),
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        //console.log("API response:", data);
        if (data.actionStatus === 200) {
          // alert("Saved Successfully!");
          notification.open({
            description: "Attestation Updated Successfully",
            type: "success", // this sets the success color
          });
          // this.GetCSNPSubscribers();

          //  this.getAllCSNP(true, 1, 5, 0, 1);
          this.resetFields();
          this.setState({ showAttestationModal: false });
        } else {
          // alert("Error: " + data.message);
          notification.open({
            message: "Error",
            description: data.message || "Something went wrong",
            type: "error",
          });
          this.setState({ showAttestationModal: false });
          //console.log("error")
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // alert("Something went wrong. Please try again.");
      });
  };
  //-------------------------------------------------------

  getPendingMessage = () => {
    const isCSNPPending = localStorage.getItem("IsCSNPPending") === "true";
    const isSSBCIPending = localStorage.getItem("IsSSBCIPending") === "true";
  
    if (isCSNPPending && isSSBCIPending) {
      return "Both CSNP and SSBCI have pending attestations.";
    } else if (isCSNPPending) {
      return "You have pending CSNP attestations.";
    } else if (isSSBCIPending) {
      return "You have pending SSBCI attestations.";
    }
    return null;
  };
  handleSSBCISelect = (code) => {
    this.setState((prev) => ({
      ssbciConditions: prev.ssbciConditions.map((item) =>
        item.LookUp_Code === code
          ? { ...item, selected: item.selected === 1 ? 0 : 1 }
          : item
      ),
    }));
  };
  handlePcpChange = (selectedValues) => {
   // const { pcpNameOptions } = this.state;
    const { activeModule, csnpPcpNameOptions, ssbciPcpNameOptions } = this.state;
    
    const pcpNameOptions =
         activeModule === "SSBCI"
         ? ssbciPcpNameOptions
         : csnpPcpNameOptions;
   
    if (selectedValues.includes("ALL")) {
      const allSelected = this.state.selectedPcpNames.length === pcpNameOptions.length;
      console.log("inside all")
      this.setState({
        selectedPcpNames: allSelected ? [] : [...pcpNameOptions]
      },
    );
      return;
    }
   
    this.setState({
      selectedPcpNames: selectedValues
    },
  );
  };
  getFirstProviderNpi = () => {
    try {
      const providerRole = sessionStorage.getItem("ProviderRole");
      const roleName = sessionStorage.getItem("rolename") || "";
  
      // Provider
      if (providerRole === "PROVIDER") {
        const npiValue = JSON.parse(
          sessionStorage.getItem("npivalue") || "[]"
        );
  
        return npiValue?.[0] || "";
      }
  
      // Group User / IPA User
      if (
        roleName.includes("Group User") ||
        roleName.includes("IPA User")
      ) {
        const mappingKey = roleName.includes("IPA User")
          ? "latestTaxidNpiMapping"
          : "taxidNpiMapping";
  
        const mappingData = JSON.parse(
          sessionStorage.getItem(mappingKey) || "[]"
        );
  
        // Example:
        // [
        //   { TaxID: "593140335", NPI: ["1124475884", "1861470916"] }
        // ]
  
        for (const item of mappingData) {
          if (Array.isArray(item.NPI) && item.NPI.length > 0) {
            return item.NPI[0];
          }
  
          // Also support:
          // { TaxID: "...", NPI: "1124475884" }
          if (item.NPI) {
            return item.NPI;
          }
        }
      }
  
      return "";
    } catch (error) {
      console.error("Failed to get first provider NPI:", error);
      return "";
    }
  };
  
  render() {
    // //console.log(typeof(this.props.taxId))
    // //console.log("-props in auth page", this.props.subId);
    //console.log("state****",this.state.attestationdateOnChange)
    const completedStatuses = [
      "CSNP_ACCP", "CSNP_AUCCNP", "CSNP_AUCCWN", "CSNP_AUCICCP",
      "SSBCI_AUCCNP","SSBCI_AUCCWN", "SSBCI_AUCICCP", "SSBCI_ACCP",
      "SSBCI_CCB", "SSBCI_CCC", "SSBCI_CCCP", "SSBCI_UCCNP", "SSBCI_UCCWN"
    ];
    const isCompleted = completedStatuses.includes(this.state.selectedUserStatus);
    const showIncorrectConditionMsg = this.state.enrollmentStatus === "CSNP_AUCICCP";

    const planName = sessionStorage.getItem("planName");
    const cvdSupportedPlans = {
      ultimate: [
        "021",
        "026",
        "029",
        "033",
        "050",
        "051",
        "052"
      ],
      liberty: ["004"],
      csh: [
        "005",
        "006",
        "002",
        "003"
      ]
    };
    
    const isSolisMentalPbp =
    planName === "solis" &&
    ["027", "034"].includes(String(this.state.pbpCode));
    
    const showChronicConditions =
    planName === "solis" ||
    cvdSupportedPlans[planName]?.includes(this.state.pbpCode);
    // console.log("showChronicConditions",cvdSupportedPlans[planName])
    // console.log("state",this.state.pbpCode)
    // console.log("true/false: ",cvdSupportedPlans[planName]?.includes(this.state.pbpCode))

    const cldSupportedPlans = {
      ultimate: [
        "023",
        "025",
      ],
    };
    const showCldConditions = cldSupportedPlans[planName]?.includes(this.state.pbpCode);
    const isUltimateSSBCI =
    sessionStorage.getItem("planName") === "ultimate" &&
    this.state.activeModule === "SSBCI";

    const isUltimateSSBCIFieldsMissing =
    isUltimateSSBCI &&
    (
      !/^\d{10}$/.test(this.state.npi?.trim() || "") ||
      !/^\d{10}$/.test(this.state.phoneNumber?.trim() || "")
    );
    // console.log("showCldConditions",cldSupportedPlans[planName])
    // console.log("state cld: ",this.state.pbpCode)
    // console.log("true/false: ",cldSupportedPlans[planName]?.includes(this.state.pbpCode))


    const { showAttestationModal, selectedUser } = this.state;

    if (this.state.authPage != "1" && this.state.authPage != "2") {
      this.state.memberDetailsSubscriberId = this.props.subId.SubscriberID;
    } else {
      this.state.memberDetailsSubscriberId = "";
    }
    const {
      currentPage,
      todosPerPage,
      upperPageBound,
      lowerPageBound,
      isPrevBtnActive,
      isNextBtnActive,
    } = this.state;

    const { getFieldDecorator } = this.props.form;
    // var currentTodos;
    console.log("datass we got", this.state.attestationListData);
    this.state.filterData = this.state.attestationListData.filter((e) => {
      // console.log("e inside @@", e.effectiveDate);
      var req =
        e.Req === null || e.Req === undefined ? "" : e.Req.replace(/\s+/g, " ");
      var abv =
        e.Abv === null || e.Abv === undefined ? "" : e.Abv.replace(/\s+/g, " ");
      var attestedBy =
        e.attestedBy === null || e.attestedBy === undefined
          ? ""
          : e.attestedBy.replace(/\s+/g, " ");
      var pcpName =
        e.pcpName === null || e.pcpName === undefined
          ? ""
          : e.pcpName.replace(/\s+/g, " ");
      var subId =
        e.subsciberId === null || e.subsciberId === undefined
          ? ""
          : e.subsciberId.replace(/\s+/g, " ");
      var mbi =
        e.mbi === null || e.mbi === undefined ? "" : e.mbi.replace(/\s+/g, " ");
      var attestationType =
        e.attestationType === null || e.attestationType === undefined
          ? ""
          : e.attestationType.replace(/\s+/g, " ");
      var memberName =
        e.memberName === null || e.memberName === undefined
          ? ""
          : e.memberName.replace(/\s+/g, " ");
      //var dos = e.effectiveDate === null || e.effectiveDate === undefined ? "" : new Date(e.effectiveDate).toLocaleDateString("en-US");
      var dos =
        e.effectiveDate === null || e.effectiveDate === undefined
          ? ""
          : new Date(e.effectiveDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
      //console.log("attestationdate@@##",dos)
      //console.log("####",this.state.filterDOS)
      var fromdate =
        e.FromDate === null || e.FromDate === undefined
          ? ""
          : e.FromDate.replace(/\s+/g, " ");
      var attestationdate =
        e.attestationDate === null || e.attestationDate === undefined
          ? ""
          : new Date(e.attestationDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
      var applicationDate =
        e.applicationDate === null || e.applicationDate === undefined
          ? ""
          : new Date(e.applicationDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
      // //console.log("attestationdate@@##",attestationdate)
      var todate =
        e.ToDate === null || e.ToDate === undefined
          ? ""
          : e.ToDate.replace(/\s+/g, " ");
      var status =
        e.status === null || e.status === undefined
          ? ""
          : e.status.replace(/\s+/g, " ");
      var pos =
        e.POS === null || e.POS === undefined ? "" : e.POS.replace(/\s+/g, " ");
      var auth =
        e.Auth === null || e.Auth === undefined
          ? ""
          : e.Auth.replace(/\s+/g, " ");
      var servicingProvider =
        e.ServicingProvider === null || e.ServicingProvider === undefined
          ? ""
          : e.ServicingProvider.replace(/\s+/g, " ");
      var facilityName =
        e.FacilityName === null || e.FacilityName === undefined
          ? ""
          : e.FacilityName.replace(/\s+/g, " ");

      if (this.state.searchColumn) {
        //console.log("search@@ ",this.state.searchColumn)
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterReq.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterAbv.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterReference.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterSubId.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterMbiId.toLocaleLowerCase()); // filterMbiId
      } else if (this.state.searchColumn) {
        //console.log("column@@",this.state.searchColumn)
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterStatusCode.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterAttestatedBy.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterPcpName.toLocaleLowerCase());
      }
       else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterMemberName.toLocaleLowerCase());
      }    else if (this.state.searchColumn) {
            return e[this.state.searchColumn]
              .toString()
              .toLowerCase()
              .includes(this.state.filterattestationType.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        //console.log("ssssshiv",e[this.state.searchColumn])
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.attestationdateOnChange.toLocaleLowerCase());
      }    else if (this.state.searchColumn) {
            //console.log("ssssshiv",e[this.state.searchColumn])
            return e[this.state.searchColumn]
              .toString()
              .toLowerCase()
              .includes(this.state.applicationdateOnChange.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterStatus.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterPos.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterAuth.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterMode.toLocaleLowerCase());
      } else if (this.state.searchColumn) {
        return e[this.state.searchColumn]
          .toString()
          .toLowerCase()
          .includes(this.state.filterDx.toLocaleLowerCase());
      }
      return (
        req.toLowerCase().includes(this.state.filterReq.toLowerCase()) &&
        abv.toLowerCase().includes(this.state.filterAbv.toLowerCase()) &&
        attestedBy
          .toLowerCase()
          .includes(this.state.filterReference.toLowerCase()) &&
        subId.toLowerCase().includes(this.state.filterSubId.toLowerCase()) &&
        mbi.toLowerCase().includes(this.state.filterMbiId.toLowerCase()) &&
        attestedBy
          .toLowerCase()
          .includes(this.state.filterAttestatedBy.toLowerCase()) &&
        pcpName
          .toLowerCase()
          .includes(this.state.filterPcpName.toLowerCase()) &&
        memberName
          .toLowerCase()
          .includes(this.state.filterMemberName.toLowerCase()) &&
        attestationType
        .toLowerCase()
        .includes(this.state.filterattestationType.toLowerCase()) &&
        dos.toLowerCase().includes(this.state.filterDOS.toLowerCase()) &&
        fromdate
          .toLowerCase()
          .includes(this.state.filterFromData.toLowerCase()) &&
        // new Date(dos).toLocaleDateString("en-US")
        //    .toLowerCase()
        //    .includes(this.state.filterDOS.toLowerCase()) &&
        attestationdate
          .toLowerCase()
          .includes(this.state.attestationdateOnChange.toLowerCase()) &&
        applicationDate
          .toLowerCase()
          .includes(this.state.applicationdateOnChange.toLowerCase()) &&
        // new Date(attestationdate).toLocaleDateString("en-US")
        //    .toLowerCase()
        //    .includes(this.state.attestationdateOnChange.toLowerCase()) &&
        // todate.toLowerCase().includes(this.state.filterToData.toLowerCase()) &&
        (!this.state.filterStatusCode ||
          this.state.filterStatusCode.trim() === "" ||
          this.state.filterStatusCode
            .toLowerCase()
            .split(",")
            .includes(status.toLowerCase())) &&
        pos.toLowerCase().includes(this.state.filterPos.toLowerCase()) &&
        auth.toLowerCase().includes(this.state.filterAuth.toLowerCase()) &&
        servicingProvider
          .toLowerCase()
          .includes(this.state.filterServicing.toLowerCase()) &&
        facilityName
          .toLowerCase()
          .includes(this.state.filterFacility.toLowerCase())
      );
    });

    const pageNumbers = [];
    //console.log("ssss@@@",this.state.totalRecords)

    // for (let i = 1; i <= this.state.totalRecords; i++) {
    //   pageNumbers.push(i);
    // }
    const totalPages = Math.ceil(this.state.totalRecords / 10); // assuming 10 records per page
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(i);
    }
    //console.log("totalPages@@",totalPages)
    //console.log(" state total record##",this.state.totalRecords)

    const renderPageNumbers = pageNumbers.map((number, index) => {
      if (number === 1 && currentPage === 1) {
        return (
          <div>
            <li
              key={index}
              className="active"
              id={number}
              onClick={this.handleClick}
            >
              <a href="#" id={number}>
                {number}
              </a>
            </li>
          </div>
        );
      } else if (number < upperPageBound + 1 && number > lowerPageBound) {
        return (
          <li key={number} id={number} onClick={this.handleClick}>
            <a href="#" id={number}>
              {number}
            </a>
          </li>
        );
      }
    });

    let pageIncrementBtn = null;
    if (pageNumbers.length > upperPageBound) {
      pageIncrementBtn = (
        <li className="">
          <a href="#" onClick={this.btnIncrementClick}>
            {" "}
            &hellip;{" "}
          </a>
        </li>
      );
    }
    let pageDecrementBtn = null;
    if (lowerPageBound >= 1) {
      pageDecrementBtn = (
        <li className="">
          <a href="#" onClick={this.btnDecrementClick}>
            {" "}
            &hellip;{" "}
          </a>
        </li>
      );
    }
    let renderPrevBtn = null;
    if (isPrevBtnActive === "disabled") {
      renderPrevBtn = (
        <li className="isPrevBtnActive pageDisabled">
          <img src={PreviousIcon} alt="Left Arrow" />
        </li>
      );
    } else {
      renderPrevBtn = (
        <li className="isPrevBtnActive" onClick={this.btnPrevClick}>
          <img src={PreviousIcon} alt="Left Arrow" id="btnPrev" />
        </li>
      );
    }
    let renderNextBtn = null;
    if (isNextBtnActive === "disabled") {
      renderNextBtn = (
        <li className="isNextBtnActive pageDisabled">
          <img src={NextIcon} alt="Right Arrow" />
        </li>
      );
    } else if (this.state.currentPage === 1 && this.state.totalPages === 1) {
      renderNextBtn = (
        <li className="isNextBtnActive pageDisabled">
          <img src={NextIcon} alt="Right Arrow" />
        </li>
      );
    } else {
      renderNextBtn = (
        <li className="isNextBtnActive " onClick={this.btnNextClick}>
          <img src={NextIcon} alt="Right Arrow" id="btnNext" />
        </li>
      );
    }

    return (
      <div>
        {this.props.fromPage && (
          <div>
            {/* <ErrorBoundaries> */}
            {/* <AddEventBlock
              uniqueId={this.props.uniqueId}
              dataCount={this.state.filterData.length}
              tabName="Auth"
              userDetails={this.props.memberDetails}
              callerId={this.props.callerId}
              activeKey={this.props.activeKey}
            /> */}
            {/* </ErrorBoundaries> */}
          </div>
        )}
        <div className="mydiv">
        {/* 🔹 Buttons + Compact Pending Message (One Line) */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "8px",
  }}
>
  {/* 🔸 Left: CSNP & SSBCI Buttons */}
  <div style={{ display: "flex", alignItems: "center" }}>
  {(() => {
    // Read flags
    const isCSNPPending = localStorage.getItem("IsCSNPPending") === "true";
    const isSSBCIPending = localStorage.getItem("IsSSBCIPending") === "true";
    const { activeModule } = this.state;

    // --- CSNP Button Styles ---
    const csnpBackground =
      activeModule === "CSNP"
        ? isCSNPPending
          ? "linear-gradient(180deg, #8B0000 0%, #b22222 100%)" // chocolate red
          : "linear-gradient(180deg, #4dabff 0%, #1677ff 100%)" // blue if not pending
        : "white";

    const csnpBorder =
      activeModule === "CSNP"
        ? "none"
        : isCSNPPending
        ? "1px solid #b22222" // chocolate red border if CSNP pending
        : "1px solid #1677ff"; // blue if not pending

    // --- SSBCI Button Styles ---
    const ssbciBackground =
      activeModule === "SSBCI"
        ? isSSBCIPending
          ? "linear-gradient(180deg, #8B0000 0%, #b22222 100%)" // chocolate red
          : "linear-gradient(180deg, #4dabff 0%, #1677ff 100%)" // blue if not pending
        : "white";

    const ssbciBorder =
      activeModule === "SSBCI"
        ? "none"
        : isSSBCIPending
        ? "1px solid #b22222" // chocolate red border if SSBCI pending
        : "1px solid #1677ff"; // blue if not pending

    return (
      <>
        {/* CSNP Button */}
        <button
          onClick={() => {
            this.setState({ activeModule: "CSNP" }, () => {
              this.resetFields();
            });
          }}
          style={{
            background: csnpBackground,
            color: activeModule === "CSNP" ? "white" : "black",
            border: csnpBorder,
            borderRadius: "8px",
            padding: "6px 14px",
            marginRight: "8px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            boxShadow:
              activeModule === "CSNP"
                ? "0 2px 5px rgba(0,0,0,0.25)"
                : "0 1px 3px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease-in-out",
          }}
        >
          CSNP
        </button>

        {/* SSBCI Button */}
        {(planName === "solis" || planName === "ultimate") &&        
        <button
          onClick={() => {
            this.setState({ activeModule: "SSBCI" }, () => {
              this.resetFields();
            });
          }}
          style={{
            background: ssbciBackground,
            color: activeModule === "SSBCI" ? "white" : "black",
            border: ssbciBorder,
            borderRadius: "8px",
            padding: "6px 14px",
            cursor: "pointer",
            fontSize: "14px",
            fontWeight: "500",
            boxShadow:
              activeModule === "SSBCI"
                ? "0 2px 5px rgba(0,0,0,0.25)"
                : "0 1px 3px rgba(0,0,0,0.1)",
            transition: "all 0.2s ease-in-out",
          }}
        >
          SSBCI
        </button>
         }
      </>
    );
  })()}
</div>




  {/* 🔸 Right: Compact Message */}
  {this.getPendingMessage() && (
    <div
      style={{
        backgroundColor: "#fdecea",
        border: "1px solid #f5c2c7",
        color: "#b71c1c",
        borderRadius: "6px",
        padding: "4px 10px",
        fontSize: "13px",
        fontWeight: "500",
        display: "flex",
        alignItems: "center",
        gap: "5px",
        whiteSpace: "nowrap", // ✅ single-line
        maxWidth: "auto",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      }}
    >
      ⚠ {this.getPendingMessage()}
    </div>
  )}
</div>

          <table className="authTable authTable1">{this.tableHeader()}</table>
          {(this.state.filterReq != null && this.state.filterReq != "") ||
          this.state.filterAbv != null ||
          (this.state.filterReference != null &&
            this.state.filterReference != "") ||
          (this.state.filterSubId != null && this.state.filterSubId != "") ||
          (this.state.filterMbiId != null && this.state.filterMbiId != "") ||
          (this.state.filterMemberName != null &&
            this.state.filterMemberName != "") ||
            (this.state.filterattestationType != null &&
              this.state.filterattestationType != "") ||
          (this.state.filterToData != null && this.state.filterToData != "") ||
          (this.state.filterFromData != null &&
            this.state.filterFromData != "") ||
          (this.state.attestationdateOnChange != null &&
            this.state.attestationdateOnChange != "") ||
            (this.state.applicationdateOnChange != null &&
              this.state.applicationdateOnChange != "") ||
          (this.state.filterDOS != null && this.state.filterDOS != "") ||
          (this.state.filterStatusCode != null &&
            this.state.filterStatusCode != "") ||
          (this.state.filterPos != null && this.state.filterPos != "") ||
          (this.state.filterAuth != null && this.state.filterAuth != "") ||
          (this.state.filterFacility != null &&
            this.state.filterFacility != "") ||
          (this.state.filterServicing != null &&
            this.state.filterServicing != "") ? (
            <div className="AuthpositionRight">
              <span className="authCrossButtonBg" onClick={this.resetFields}>
                <img
                  className="actionButtons"
                  src={CrossIcon}
                  style={{ width: "11px", height: "11px" }}
                />
              </span>
              <span
                className="authSearchButtonBg"
                onClick={() =>
                  this.callActiveModuleAPI(true, 1, 5, 0, 1, "disabled", "")
                }
              >
                <img
                  className="actionButtons"
                  src={SearchIcon}
                  width="13"
                  height="13"
                />
              </span>
            </div>
          ) : (
            ""
          )}

          <table className="authTable authTable1">
            <tbody className="tableBody">
              {this.state.filterData.length > 0 &&
                this.state.SearchLoading === false &&
                this.state.authListLoading === true &&
                this.state.filterData.map((user, index) => {
                  // //console.log("Rendering row for user:", this.state.filterData);
                  // //console.log(index, user);
                  if (index <= 8) {
                    var serialNumber = "0" + (index + 1);
                  } else {
                    var serialNumber = index + 1;
                  }
                  // this.state.serialNumber = this.state.todosPerPage * (this.state.currentPage - 1) + index + 1
                  return (
                    <tr
                      key={index}
                      onClick={() => this.getAttestationDetails(user)}
                    >
                      {/* <td>{this.state.todosPerPage * (this.state.currentPage - 1) + index + 1}.</td> */}
                      <td>{serialNumber}</td>
                      <td style={{ width: "120px" }}>{user.subsciberId}</td>
                      <td style={{ width: "120px" }}>{user.mbi}</td>
                      <td style={{ width: "150px" }}>{user.memberName}</td>
                      <td style={{ width: "130px" }}>{user.attestationType}</td>
                      <td style={{ width: "135px" }}>
                      {user.applicationDate
                          ? new Date(user.applicationDate).toLocaleDateString(
                              "en-US"
                            )
                          : "---"}
                      </td>
                      <td style={{ width: "135px" }}>
                        {user.attestationDate
                          ? new Date(user.attestationDate).toLocaleDateString(
                              "en-US"
                            )
                          : "---"}
                      </td>
                      <td style={{ width: "150px" }}>
                        {user.pcpName ? user.pcpName : "---"}
                      </td>
                      <td style={{ width: "150px" }}>
                        {user.attestedBy ? user.attestedBy : "---"}
                      </td>
                      <td style={{ width: "135px" }}>
                        {user.effectiveDate
                          ? new Date(user.effectiveDate).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              }
                            )
                          : "---"}
                      </td>

                      <td style={{ width: "110px" }}>
                        {this.getStatusLabel(user.status)}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
          {this.state.SearchLoading === true && (
            <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
              <Spin size="large" tip="Loading..." />
            </div>
          )}
          {this.state.filterData.length === 0 &&
            this.state.SearchLoading === false &&
            this.state.authListLoading === false && (
              <div className="mt-5 mb-5 h3 d-flex justify-content-center ">
                <Spin size="large" tip="Loading..." />
              </div>
            )}
          {this.state.filterData.length === 0 &&
            this.state.SearchLoading === false &&
            this.state.authListLoading === true && (
              <div className="mt-5 mb-5 h5 d-flex justify-content-center ">
                <span>
                     {this.state.isPageSearch
                      ? "Please Click On The Search Button To View The Result"
                      : "No Data Found!"}
                </span>
              </div>
            )}
        </div>
        {this.state.filterData.length > 0 && (
          //console.log("dddd",this.state.filterData),
          //console.log("ffff",this.state.totalRecordFound),
          <div className="page-bottom" style={{ marginTop: "8px" }}>
            {this.state.totalRecordFound > 10 ? (
              //console.log("gggg",this.state.totalRecordFound),
              <ul
                className="pagination"
                style={{ margin: "0px", padding: "0px" }}
              >
                {renderPrevBtn}
                {pageDecrementBtn}
                {renderPageNumbers}
                {pageIncrementBtn}
                {renderNextBtn}
              </ul>
            ) : (
              <div></div>
            )}
          </div>
        )}
        <Modal
          title={
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span> {this.state.activeModule} Attestation Form</span>
              </div>
              <div style={{ fontSize: 13, marginTop: 6 }}>
                <span>Sub ID:</span>{" "}
                <span
                  style={{
                    color: isCompleted ? "#52c41a" : "inherit",
                    fontWeight: isCompleted ? "600" : "normal",
                  }}
                >
                  {this.state.subIDToShow || "N/A"}
                </span>
              </div>
            </div>
          }
          open={this.state.showAttestationModal}
          onCancel={this.handleModalCancel}
          maskClosable={false} // This prevents closing when clicking outside the modal
          footer={[
            <button
              key="cancel"
              onClick={this.handleModalCancel}
              style={{
                padding: "6px 16px",
                border: "1px solid #ccc",
                borderRadius: 4,
                backgroundColor: "#fff",
                marginRight: 16, // Add spacing to the right
              }}
            >
              Cancel
            </button>,
            <button
              key="save"
              onClick={this.handleModalSave}
              disabled={
                this.state.selectedUserStatus === "CSNP_ACCP" || 
                this.state.selectedUserStatus === "CSNP_AUCCNP" ||
                this.state.selectedUserStatus === "CSNP_AUCCWN" ||
                this.state.selectedUserStatus === "CSNP_AUCICCP" ||
                this.state.selectedOption === "SSBCI_APPR" ||   // 🔥 NEW CONDITION
                !this.state.selectedOption ||
                !this.state.attestationDate ||
                isUltimateSSBCIFieldsMissing ||  // Ultimate SSBCI mandatory fields
                (this.state.selectedOption === "hasConditions" &&
                  !(
                    this.state.conditions.cvd ||
                    this.state.conditions.diabetes ||
                    this.state.conditions.chronicHeartFailure ||
                    this.state.conditions.cld ||
                    this.state.conditions.mental
                  )
                )
              }
              
              style={{
                padding: "6px 16px",
                border: "none",
                borderRadius: 4,
                backgroundColor:
                  this.state.isReadOnly ||
                  !this.state.selectedOption ||
                  this.state.selectedOption === "SSBCI_APPR" ||   // ⭝ NEW CONDITION
                  !this.state.attestationDate ||
                  isUltimateSSBCIFieldsMissing ||
                  (this.state.selectedOption === "hasConditions" &&
                    !(
                      this.state.conditions.cvd ||
                      this.state.conditions.diabetes ||
                    this.state.conditions.chronicHeartFailure ||
                    this.state.conditions.cld ||
                      this.state.conditions.mental
                    ))
                    ? "#a0c4ff" // light blue (disabled)
                    : "#1677ff", // active blue
                color: "#fff",
              }}
              
            >
              Update
            </button>,
          ]}
          bodyStyle={{ padding: 24 }}
          width={600}
        >
          <Form layout="vertical">
            <Form.Item>
              <div className={this.state.isReadOnly ? "read-only-mode" : ""}>
      
              <div 
                style={{ display: "flex", flexDirection: "column", gap: 16 }}
              >
              {/* --- CSNP CONTENT --- */}
              {this.state.activeModule === "CSNP" ? (
                <Radio.Group
                  onChange={this.handleOptionChange}
                  value={this.state.selectedOption}
                  style={{ display: "flex", flexDirection: "column", gap: 12 }}
                  disabled={this.state.isReadOnly}
                >
                  <Radio value="hasConditions">
                    <div>
                      <div>This is my patient and has the conditions of:</div>
                    </div>
                  </Radio>
                  {/* INFO MESSAGE */}
                  {this.state.selectedOption === "hasConditions" &&
                    !(
                      this.state.conditions.cvd ||
                      this.state.conditions.diabetes ||
                    this.state.conditions.chronicHeartFailure ||
                    this.state.conditions.cld ||
                      this.state.conditions.mental
                    ) && (
                      <div style={{ color: "#faad14", fontSize: 13, paddingLeft: 28 }}>
                        Please select at least one condition.
                      </div>
                    )}
                  <div
                    style={{
                      paddingLeft: 28,
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    {
                    showChronicConditions && !isSolisMentalPbp && (
                    <>
                    <Checkbox
                      name="cvd"
                      style={{ marginLeft: "8px" }} 
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.cvd}
                      onChange={this.handleCheckboxChange}
                    >
                      {" "}
                      {planName === "solis" ? "Cardiovascular Diseases (CVDs)/Chronic Heart Failure (CHF)" : "Cardiovascular Diseases (CVD)"}
                    </Checkbox>
                    <Checkbox
                      name="diabetes"
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.diabetes}
                      onChange={this.handleCheckboxChange}
                    >
                      Diabetes Mellitus
                    </Checkbox>
                    {planName !== "solis" && (
                    <Checkbox
                      name="chronicHeartFailure"
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.chronicHeartFailure}
                      onChange={this.handleCheckboxChange}
                    >
                      Chronic Heart Failure
                    </Checkbox>
                    )}
                    </>
                    )
                    }
                    { isSolisMentalPbp && (
                    <Checkbox
                      name="mental"
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.mental}
                      onChange={this.handleCheckboxChange}
                    >
                      Mental Health Condition (that is, bipolar disorders, major depressive disorders, paranoid disorder, schizophrenia, and/or schizoaffective disorder)
                    </Checkbox>
                  )}
                {/* Chronic Lung Disorder/COPD is only for up now */}
                  {showCldConditions &&
                    <Checkbox
                      name="cld"
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.cld}
                      onChange={this.handleCheckboxChange}
                    >
                      Chronic Lung Disorder/COPD
                    </Checkbox>
                    }
                    {/* Only for CSH --> Diabetes, Chronic Heart Failure (CHF), or Cardiovascular Disorder (CVD)  */}
                    {sessionStorage.getItem("planName") === "csh" && (
                    <Checkbox
                      name="mental"
                      disabled={
                        this.state.isReadOnly ||
                        this.state.selectedOption !== "hasConditions"
                      }
                      checked={this.state.conditions.mental}
                      onChange={this.handleCheckboxChange}
                    >
                      Diabetes, Chronic Heart Failure (CHF), or Cardiovascular Disorder (CVD) 
                    </Checkbox>
                  )}
                  </div>

                  <Radio value="noConditions">
                    This is my patient, but I do not confirm the presence of
                    either condition above.
                  </Radio>

                  <Radio value="notMyPatient">This is not my patient.</Radio>
                </Radio.Group>
                
              ) : this.state.activeModule === "SSBCI" ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 12,
                  }}
                >
                  {/* Option 1: Confirm */}
                  <Checkbox
                    checked={this.state.selectedOption === "SSBCI_ACCP" ||
                      this.state.selectedOption === "SSBCI_CCB" ||
                      this.state.selectedOption === "SSBCI_CCCP"
                    }
                    disabled={this.state.isReadOnly}
                    onChange={() => this.handleOptionChange({ target: { value: "SSBCI_ACCP" } })}
                  >
                    {
                      planName === "ultimate"
                       ?  <>
                        I confirm that my records indicate this patient meets all of the following criteria:
                       <br />
                       (1) Has one or more of the below comorbid and medically complex chronic conditions
                       that are life-threatening or significantly limit the patient’s overall health or function,
                       <br />
                       (2) Is at high risk of hospitalization or other adverse health outcomes,
                       <br />
                       (3) Requires intensive care coordination.
                     </>
                       : "I confirm my records for this patient include a diagnosis of one or more of the above qualifying conditions and the patient is at high risk of hospitalization or other adverse health outcomes."
                    }
                  </Checkbox>

                  {/* READ-ONLY Conditions List */}
                  {this.state.ssbciConditions && (
                    <ul
                      style={{
                        listStyleType: 'disc',
                        paddingLeft: 40,
                        marginTop: -4,
                        marginBottom: 4,
                        color: '#525252' 
                      }}
                    >
                      {/* Mapping the dynamic data to the read-only list */}
                      {this.state.ssbciConditions
                          .filter(item => item.selected === 1)
                          .map((item) => (
                          <li key={item.LookUp_Code}>
                              {item.LookUp_Desc}
                          </li>
                      ))}
                    </ul>
                  )}

                  {/* Option 2: No Confirm */}
                  <Checkbox
                    checked={this.state.selectedOption === "SSBCI_AUCCWN" ||
                      this.state.selectedOption === "SSBCI_UCCWN"
                    }
                    disabled={this.state.isReadOnly}
                    onChange={() => this.handleOptionChange({ target: { value: "SSBCI_AUCCWN" } })}
                    style={{ whiteSpace: 'normal' }}
                  >
                    No, my records for this patient do not include a diagnosis of one or more of the above qualifying conditions, is at high risk of hospitalization or other adverse health outcomes.
                  </Checkbox>

                  {/* Option 3: Not My Patient */}
                  <Checkbox
                    checked={this.state.selectedOption === "SSBCI_AUCCNP" || this.state.selectedOption === "SSBCI_UCCNP"}
                    disabled={this.state.isReadOnly}
                    onChange={() => this.handleOptionChange({ target: { value: "SSBCI_AUCCNP" } })}
                  >
                    My records indicate this is **not** my patient.
                  </Checkbox>
                     {/* ✅ NEW: Phone Number Field */}
                     {sessionStorage.getItem("planName") === "ultimate" && (
      <div style={{ display: "flex", gap: "16px", marginTop: "10px" }}>
    {/* Phone Number */}
        <div style={{ flex: 1 }}>
          <label>Phone Number <span style={{ color: "red" }}>*</span></label>
          <Input
            placeholder="Enter 10 digit Phone Number"
            value={this.state.phoneNumber}
            maxLength={10}
         onChange={(e) => {
          // Allow numbers only
          const value = e.target.value.replace(/\D/g, "");

          this.setState({
            phoneNumber: value,
          });
        }}
            disabled={this.state.isReadOnly}
            style={{ marginTop: 4 }}
          />

      {/* Phone Number Validation Warning */}
      {this.state.phoneNumber &&
        !/^\d{10}$/.test(this.state.phoneNumber.trim()) && !isCompleted && (
          <div
            style={{
              color: "red",
              fontSize: "12px",
              marginTop: "4px",
            }}
          >
            Phone Number must be exactly 10 digits.
          </div>
        )}
    </div>

    {/* NPI */}
    <div style={{ flex: 1 }}>
      <label>
        NPI <span style={{ color: "red" }}>*</span>
      </label>

      <Input
        placeholder="Enter 10 digit NPI"
        value={this.state.npi}
        maxLength={10}
        onChange={(e) => {
          // Allow numbers only
          const value = e.target.value.replace(/\D/g, "");

          this.setState({
            npi: value,
          });
        }}
        disabled={this.state.isReadOnly}
        style={{ marginTop: 4 }}
      />

      {/* NPI Validation Warning */}
      {this.state.npi &&
        !/^\d{10}$/.test(this.state.npi.trim()) && (
          <div
            style={{
              color: "red",
              fontSize: "12px",
              marginTop: "4px",
            }}
          >
            NPI must be exactly 10 digits.
          </div>
        )}
    </div>
  </div>
)}

                </div>

              ) : null}
              </div>
              </div>
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Attestation Date (represents your signature)
                  <span style={{ color: "red" }}> *</span>
                </span>
              }
            >
              <DatePicker
                format="MM-DD-YYYY"
                style={{ width: "100%" }}
                value={this.state.attestationDate}
                disabled={this.state.isReadOnly} // ✅ disables editing when status is completed
                onChange={(date) => this.setState({ attestationDate: date })}
                placeholder="mm-dd-yyyy"
              />
            </Form.Item>
            {showIncorrectConditionMsg && (
               <Form.Item>
                  <div style={{ color: "#cf1322", fontWeight: 500 }}>
                     Incorrect condition confirmed for member's enrolling plan
                  </div>
               </Form.Item>
            )}
          </Form>
        </Modal>
      </div>
    );
  }
}

// export default AuthUserList;
export default Form.create({ name: "AttestationList" })(AttestationList);
